/* unplugin-vue-components disabled */import script from "./Admin.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin.vue?vue&type=script&setup=true&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=fecfb43c&lang=css"

const __exports__ = script;

export default __exports__